import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Segments whose case matters: email template names are SES keys
 * ("reservationRequestPendingSupport"), so `/email-template/:name` keeps it,
 * in the path and inside a `returnto=%2Femail-template%2F…` link back to it.
 */
const KEEP_CASE = /email-template(?:\/|%2f)([^/?#&]+)/gi;

/**
 * Admin links and bookmarks are case-insensitive: the URL is lower-cased on
 * parse, except the segments in KEEP_CASE.
 */
@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(lowerCaseUrl(url));
  }
}

export function lowerCaseUrl(url: string): string {
  const lowered = url.toLowerCase();
  // Only ASCII keeps its length when lower-cased; anything else is lower-cased whole.
  if (lowered.length !== url.length) return lowered;
  let out = lowered;
  for (const m of url.matchAll(KEEP_CASE)) {
    const start = (m.index ?? 0) + m[0].length - m[1].length;
    out = out.slice(0, start) + m[1] + out.slice(start + m[1].length);
  }
  return out;
}
